import BlobUploadUtils from '../../../../common/utils/BlobUploadUtils';
import {
  getBlobUrlWithSasTokenForUpload,
  getBlobUrlWithSasTokenForDownload,
  deleteFileFromBlob,
} from './LogBook.actions';

export const TransferToBlob = async (
  instrumentSerialNumber,
  localFile,
  file,
  uploadProgressHandler,
  abortSignal
) => {
  const blobUrlRes = await getBlobUrlWithSasTokenForUpload(instrumentSerialNumber, file);

  const blobUrl = blobUrlRes.body.storageUrlWithBlobSasToken.split('?')[0];

  const blockBlobClient = await BlobUploadUtils.createBlockBlobClient(
    blobUrlRes.body.storageUrlWithBlobSasToken
  );

  let doesBlobExist = await blockBlobClient.exists();

  if (doesBlobExist === true) {
    throw new Error('File with the same name already exists.');
  } else {
    await BlobUploadUtils.uploadToBlobStorage(
      blockBlobClient,
      localFile,
      uploadProgressHandler,
      abortSignal
    );

    return blobUrl;
  }
};

export const GetFileFromBlob = async (instrumentSerialNumber, file) => {
  const blobUrlRes = await getBlobUrlWithSasTokenForDownload(instrumentSerialNumber, file);

  return blobUrlRes.body.storageUrlWithBlobSasToken;
};

export const DeleteFileFromBlob = async (blobLink) => {
  await deleteFileFromBlob(blobLink);
};

export const FormatUploadFileName = (fileName) => {
  return fileName.replace(/ /g, '_');
};
